import {
  CreditCardFilled,
  DashboardOutlined,
  ScanOutlined,
  UserOutlined,
  UserSwitchOutlined,
  LeftOutlined,
  LeftCircleFilled,
  ShopFilled,
  PicCenterOutlined, // Ikon panah ke kiri
} from "@ant-design/icons";
import { Layout, Menu, Drawer, theme, Button } from "antd";
import { useContext, useState } from "react";
import { MainContext } from "./DashboardUser";
import { Link } from "react-router-dom";
import Logo from "../../../component/Logo/Logo";
import { useMediaQuery } from "react-responsive";

const { Sider } = Layout;

const Sidebar = () => {
  const { collapsed } = useContext(MainContext);
  const [drawerVisible, setDrawerVisible] = useState(false); // State untuk mengontrol visibilitas drawer
  const isMobile = useMediaQuery({ maxWidth: 768 }); // Deteksi perangkat mobile

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // Fungsi untuk menutup Drawer setelah klik menu
  const handleMenuClick = () => {
    if (isMobile) {
      setDrawerVisible(false); // Tutup Drawer jika mobile
    }
  };

  const items = [
    {
      label: (
        <Link to="/user" onClick={handleMenuClick}>
          Job
        </Link>
      ),
      key: "dashboard",
      icon: <ShopFilled />,
    },
    // {
    //   label: (
    //     <Link to="statistic" onClick={handleMenuClick}>
    //       Statistic
    //     </Link>
    //   ),
    //   key: "statistic",
    //   icon: <DashboardOutlined />,
    // },
    {
      label: (
        <Link to="event-admin" onClick={handleMenuClick}>
          Event
        </Link>
      ),
      key: "event",
      icon: <PicCenterOutlined />,
    },

    {
      label: (
        <Link to="profile" onClick={handleMenuClick}>
          Profile
        </Link>
      ),
      key: "profile",
      icon: <UserOutlined />,
    },
  ];

  // Jika mobile, gunakan Drawer
  if (isMobile) {
    return (
      <>
        {/* Tombol untuk membuka Drawer */}
        <div
          style={{
            position: "fixed",
            top: 16,
            left: 16,
            zIndex: 999,
            background: "#fff",
            padding: "8px 12px",
            borderRadius: "50%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
          }}
          onClick={() => setDrawerVisible(true)}
        >
          ☰
        </div>

        {/* Drawer untuk tampilan mobile */}
        <Drawer
          placement="left"
          closable={false}
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          width={256} // Lebar drawer
        >
          {/* Header Drawer dengan logo dan tombol tutup */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 20,
              padding: "0 16px",
            }}
          >
            {/* Logo */}
            <Link to="/" className="menuItem">
              <Logo />
            </Link>

            {/* Tombol tutup dengan ikon panah ke kiri */}
            <Button
              type="text"
              icon={<LeftCircleFilled />}
              onClick={() => setDrawerVisible(false)}
              style={{
                fontSize: "18px",
                color: "#000",
                padding: 0,
              }}
            />
          </div>

          {/* Menu */}
          <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={items}
          />
        </Drawer>
      </>
    );
  }

  // Jika desktop, gunakan Sidebar seperti biasa
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{ background: colorBgContainer }}
    >
      {/* Header Sidebar dengan logo */}
      <div
        style={{
          textAlign: "center",
          paddingTop: 16,
          paddingBottom: 16,
        }}
      >
        <Link to="/" className="menuItem">
          <Logo
            style={{
              width: "100px", // Ukuran logo lebih besar
              height: "100px", // Proporsional dengan lebar
            }}
          />
        </Link>
      </div>

      {/* Menu */}
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["1"]}
        items={items}
      />
    </Sider>
  );
};

export default Sidebar;
